import { render, staticRenderFns } from "./Tip6.vue?vue&type=template&id=45759c3b&scoped=true&lang=pug"
import script from "./Tip6.vue?vue&type=script&lang=ts"
export * from "./Tip6.vue?vue&type=script&lang=ts"
import style0 from "./Tip6.vue?vue&type=style&index=0&id=45759c3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45759c3b",
  null
  
)

export default component.exports